var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudButPlayerPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .pausefill {\n        fill: currentColor;\n        stroke: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "pausefill",
    x: 10.34,
    y: 5.21,
    width: 10.41,
    height: 39.56,
    rx: 3.12,
    ry: 3.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "pausefill",
    x: 29.23,
    y: 5.21,
    width: 10.41,
    height: 39.56,
    rx: 3.12,
    ry: 3.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudButPlayerPause);
export default __webpack_public_path__ + "static/media/cloud_but_player_pause.2e6ed7e3558b835452ba673187af1aff.svg";
export { ForwardRef as ReactComponent };